import axios from 'axios';
import mbpLogger from 'mbp-logger';
import mbpUtil from 'mbp-api-util';
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ENV_OBJ = {
  protocol: 'https',
  host: mbpUtil.getEnv('APP_VERIFY_ADDRESS_HOST') || 'localhost',
  authToken: mbpUtil.getEnv('APP_VERIFY_ADDRESS_AUTH_TOKEN') || '',
  passAuthTokenInHeader: false
};

/*
const setHeaders = (headersInput) => {
    const headers = { ...headersInput };
    return headers;
};

const setParams = (paramsInput) => {
    const params = { ...paramsInput };
    return params;
};
*/

/**
 * Call Axios to execute remote call to ContentStack service.
 * Note: brand will get added as parameter on the URL
 *
 * @param method       - get/post/put/delete/etc
 * @param url          - string for url to call
 * @param params       - object with parameters to be added to the url
 * @param data         - body
 * @param qasEnv       - QAS environment properties
 * @param authToken    - Auth Token
 * @param header       - object with headers to be added to the request
 */

// const { CancelToken } = axios;
// let cancel;

var callAxios = function callAxios(method, url, params, data, qasEnv, authToken, headers) {
  try {
    // Bail if no accessToken or apiKey provided
    if (!authToken) {
      return false;
    }
    /*
    if (cancel !== undefined) {
        cancel('Request failed due to a new request');
    }
    */
    var config = {
      method: method,
      url: url,
      params: params,
      headers: headers,
      data: data
      /* cancelToken: new CancelToken(((c) => {
          cancel = c;
      })), */
    };

    if (authToken && ENV_OBJ.passAuthTokenInHeader) {
      config.headers = _objectSpread({
        'Auth-Token': authToken
      }, config.headers);
    } else if (authToken && !ENV_OBJ.passAuthTokenInHeader) {
      config.params = _objectSpread({
        'auth-token': authToken
      }, config.params);
    }
    return axios(config);
  } catch (ex) {
    mbpLogger.logError({
      method: method,
      url: url,
      params: params,
      data: data,
      qasEnv: qasEnv,
      headers: headers,
      "function": 'callAxios',
      module: 'mbp-qas-address-sdk',
      jsError: ex,
      message: 'callAxios FAILED'
    });
  }
  return null;
};

/**
 * Builds the url
 * @param {*} qasEnv  - if empty uses default.
 * @param String actionType - either be search || format
 */
var getUrl = function getUrl(qasEnv, actionType) {
  mbpLogger.logDebug({
    qasEnv: qasEnv,
    actionType: actionType,
    "function": 'getUrl',
    module: 'mbp-qas-address-sdk',
    message: 'getUrl variables'
  });
  var hostUrl = "".concat(qasEnv.protocol || ENV_OBJ.protocol, "://").concat(qasEnv.host || ENV_OBJ.host);
  var url = "".concat(hostUrl, "/capture/address/v2/").concat(actionType);
  mbpLogger.logDebug({
    url: url,
    hostUrl: hostUrl,
    "function": 'getUrl',
    module: 'mbp-contentstack-sdk',
    message: 'getUrl variables'
  });
  return url;
};

/**
 * @param {*} qasEnv
 * @param String actionType - either be search || format
 * @param {*} params
 */
var qasGet = function qasGet(qasEnv, actionType, params) {
  try {
    mbpLogger.logDebug({
      params: params,
      "function": 'qasGet',
      module: 'mbp-qas-address-sdk',
      message: 'qasGet params'
    });
    var url = getUrl(qasEnv, actionType);
    var qasAuthToken = '';
    if (qasEnv.authToken) {
      qasAuthToken = qasEnv.authToken;
    } else {
      qasAuthToken = ENV_OBJ.authToken;
    }
    return callAxios('get', url, params, null, qasEnv, qasAuthToken);
  } catch (ex) {
    mbpLogger.logError({
      qasEnv: qasEnv,
      actionType: actionType,
      "function": 'qasGet',
      module: 'mbp-qas-address-sdk',
      jsError: ex,
      message: 'QAS Get Failed'
    });
  }
  return null;
};

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var QasClient = {
  qasGet: qasGet
};
export { QasClient as default };